import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from './api';

const baseUrl = `${import.meta.env.VITE_AUTOMATION_API_URL}/automation/health`;

export const automationApi = createApi({
  reducerPath: 'automationApi',
  baseQuery: (...args) => baseQueryWithReAuth(...args, { baseUrl }),
  tagTypes: ['automation'],
  endpoints: (builder) => ({
    getAutomationHealth: builder.query<{ status: string }, void>({
      query: () => ({
        url: '/',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      })
    })
  })
});

export const { useGetAutomationHealthQuery } = automationApi;
